"use client";

import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ArrowRight } from "lucide-react";
function ProjectsGrid() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div data-section-id="234726" className="columns-1 md:columns-2 gap-8 md:gap-16 lg:gap-24 mt-16 md:mt-24">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="mb-16 md:mb-24 break-inside-avoid">
            <div className="w-full bg-muted/20 animate-pulse rounded-none" style={{
          aspectRatio: i % 2 === 0 ? '3/4' : '4/5'
        }} />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="py-24 text-center text-muted-foreground">
        <p className="font-mono text-sm uppercase tracking-widest">Error retrieving portfolio data.</p>
      </div>;
  }
  if (posts.length === 0) {
    return <div className="py-24 text-center text-muted-foreground">
        <p className="font-mono text-sm uppercase tracking-widest">No architectural projects found.</p>
      </div>;
  }
  return <div className="columns-1 md:columns-2 gap-8 md:gap-16 lg:gap-24 mt-16 md:mt-24">
      {posts.map((post, i) => <div key={post.id} data-index={i} className="relative mb-24 md:mb-32 break-inside-avoid group">
          
          {}
          <div className="absolute top-8 -left-4 md:-left-12 z-20 pointer-events-none w-[120%] max-w-[150%]">
            <h3 className="text-5xl md:text-7xl lg:text-8xl font-default font-black text-transparent [-webkit-text-stroke:1px_rgba(214,194,153,0.4)] mix-blend-difference uppercase tracking-tighter leading-[0.85] opacity-0 group-hover:opacity-100 transition-opacity duration-700">
              {post.title}
            </h3>
          </div>

          <Card className="relative overflow-hidden border-0 rounded-none bg-transparent shadow-none">
            <div className="relative w-full overflow-hidden bg-muted border border-transparent group-hover:border-secondary/50 transition-colors duration-500" style={{
          aspectRatio: i % 2 === 0 ? '3/4' : '4/5'
        }}>
              {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="w-full h-full object-cover transition-transform duration-1000 ease-out group-hover:scale-110 grayscale-[0.5] group-hover:grayscale-0" /> : <div className="w-full h-full bg-muted flex items-center justify-center">
                  <span className="text-muted-foreground text-xs font-mono uppercase tracking-widest">Image Pending</span>
                </div>}

              {}
              <div className="absolute inset-0 bg-background/90 opacity-0 group-hover:opacity-100 transition-all duration-500 flex flex-col items-center justify-center p-8 z-10 backdrop-blur-sm">
                <div className="translate-y-8 group-hover:translate-y-0 transition-transform duration-500 ease-out flex flex-col items-center text-center">
                  <h4 className="text-foreground text-xl md:text-2xl font-mono font-medium mb-8 px-4 leading-tight uppercase tracking-wider">
                    {post.title}
                  </h4>
                  <Link to={post.link || "#"}>
                    <Button variant="outline" className="bg-transparent text-secondary border-secondary hover:bg-secondary hover:text-primary rounded-none uppercase tracking-widest text-[10px] h-12 px-8 transition-all duration-300 font-mono">
                      Explore Project
                      <ArrowRight className="ml-2 size-3" />
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </Card>
          
        </div>)}
    </div>;
}
export default function SignatureProjects() {
  const wp_query_params = {
    post_type: "post",
    per_page: 6,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="craftsmanship-gallery" className="py-24 md:py-32 bg-background text-foreground overflow-hidden">
      <div className="container mx-auto px-4 md:px-8 lg:px-12">
        
        {}
        <div className="max-w-3xl mb-12 md:mb-20">
          <h2 className="text-xs font-mono uppercase tracking-[0.3em] text-secondary mb-6">
            Portfolio of Excellence
          </h2>
          <p className="text-3xl md:text-5xl lg:text-6xl font-default font-black tracking-tighter text-foreground leading-[0.95] uppercase">
            Precision in every build. Structure in every detail.
          </p>
        </div>

        {}
        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 6,
        order: "desc",
        orderby: "date"
      }}>
          <ProjectsGrid />
        </PostsProvider>

        <div className="flex justify-center mt-12">
          <Link to="#">
            
          </Link>
        </div>
        
      </div>
    </section>;
}